import AxiosApi from '@/config/axios'

const LoginService = {};

LoginService.auth = (cpf, password) => {
    return AxiosApi({
        url: '/login',
        method: 'post',
        data:{
            cpf: cpf,
            password: password
        }
    })
}

LoginService.changePassword = (id, password) => {
    return AxiosApi({
        url: '/change-password',
        method: 'post',
        data:{
            id: id,
            password: password
        }
    })
}

LoginService.getUserInfo = () => {
    return AxiosApi({
        url: '/user-info',
        method: 'get',
    })
}

export default LoginService;